import { DsLocalData } from "@devsalsa/vue-core";

import AccountHandler from "@/core/shared/helpers/Account/AccountHandler";

import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

import CompanyService from "@/shared/services/CompanyService";

export default class DashboardGuard {
  /**
   * @param  {RouteLocationNormalized} to
   * @param  {RouteLocationNormalized} from
   * @param  {NavigationGuardNext} next
   * @returns void
   */
  static async withPendingSubscription(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    to.meta.companyStats = await CompanyService.stats();

    const account = await AccountHandler.getInfo();

    const referredPlanKey = DsLocalData("subscription.plan", "");
    if (
      !account.stripe_subscription &&
      !!referredPlanKey.value &&
      referredPlanKey.value !== ""
    ) {
      next({
        name: "SubscriptionPlans",
      });
    } else {
      referredPlanKey.value = "";
    }

    next();
  }
}
